import React from 'react';

export default ({ name, value, onChange, onSearchClick, ...props }) => {
  const buttonType = onSearchClick ? 'button' : 'submit';
  return (
    <div className="search-container">
      <input
        id={name}
        name={name}
        type="text"
        value={value}
        onChange={onChange}
        {...props}
      />
      <button type={buttonType} onClick={onSearchClick}>
        <i className="far fa-search" />
      </button>
    </div>
  );
};
